import React, { Component } from 'react';
import { Modal, Row, Input, Form, Alert } from 'antd';

import messager from '../../ui/messager';
import http from '../../../axios/http';
//加载中遮罩
import Loading from '../../ui/Loading';

class TaxScrapForm extends Component {

    state = {
        loadingVisible: false
    }

    //作废交易票
    scrapTicket = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            this.setState({ loadingVisible: true });
            http.post({
                url: '/taxTicket/scarpTaxTicket',
                data: values,
                success: (res) => {
                    if (this.props.successCallback) {
                        this.props.successCallback(this.props.queryData);
                    }
                    this.props.onCancel();
                    this.setState({ loadingVisible: false });
                    messager.notify("作废交易票成功！");
                },
                error: (res) => {
                    this.setState({ loadingVisible: false });
                }
            });
        });

    }

    render() {
        const { visible, onCancel, form } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                width={400}
                centered={true}
                visible={visible}
                title="作废税票"
                okText="作废"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.scrapTicket}
                afterClose={() => {
                    this.props.form.resetFields();
                }}
            >
                <Row>
                    <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                        <Form.Item label="税票号：">
                            {getFieldDecorator('taxNo', {
                                rules: [
                                    { required: true, message: '作废理由不能为空!' },
                                    { max: 16, message: '税票号不能超过16个字符！' },
                                ]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="备注：">
                            {getFieldDecorator('remark', {
                                rules: [
                                    { required: true, message: '作废理由不能为空!' },
                                    { max: 32, message: '备注不能超过32个字符！' },
                                ],
                                initialValue: '作废',
                            })(<Input />)}
                        </Form.Item>
                    </Form>
                    <Alert message="请先作废税票，再开新的税票，否则将导致作废的税票信息丢失！" type="error" />
                </Row>
                <Loading
                    visible={this.state.loadingVisible}
                    message="处理中..."
                />
            </Modal>
        )
    }
}

const TaxScrap = Form.create()(TaxScrapForm);

export default TaxScrap;